import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../index';

export interface ProductNotificationModalState {
  shouldShowNotificationModal: boolean;
  lastTimeNotificationModalWasShown: Date | null;
}

const initialState = {
  shouldShowNotificationModal: false,
  lastTimeNotificationModalWasShown: null,
} as ProductNotificationModalState;

export const productNotificationModalSlice = createSlice({
  name: 'productNotificationModal',
  initialState,
  reducers: {
    setShouldShowNotificationModal: (
      state,
      { payload }: PayloadAction<boolean>,
    ) => {
      state.shouldShowNotificationModal = payload;
    },
    setLastTimeNotificationModalWasShown: (
      state,
      { payload }: PayloadAction<Date | null>,
    ) => {
      state.lastTimeNotificationModalWasShown = payload;
    },
  },
});

export const productNotificationModalState = (state: RootState) =>
  state.productNotificationModal as ProductNotificationModalState;

export const {
  setShouldShowNotificationModal,
  setLastTimeNotificationModalWasShown,
} = productNotificationModalSlice.actions;

export default productNotificationModalSlice.reducer;
